export const shuffleArray = <T>(items: T[]): T[] => {
  const shuffled = [...items];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
  }

  return shuffled;
};

export const sampleArray = <T>(items: T[], count: number): T[] => {
  if (count >= items.length) {
    return shuffleArray(items);
  }

  return shuffleArray(items).slice(0, count);
};